import { queryOptions } from '@tanstack/react-query'

import { w } from '@/lib/api'
import { API_ENDPOINTS } from '@/lib/constants/api'

import { type ResGetLocationsQuery } from './types'

export const getLocationsQuery = queryOptions({
  queryKey: [API_ENDPOINTS.mobile.v1['nvc-cases'].locations.index],
  queryFn: (): Promise<ResGetLocationsQuery> =>
    import.meta.env.DEV
      ? w.get('/mobile/v1/nvc-cases/locations').json()
      : w.url('https://prod.lawfully-api.com/mobile/v1/nvc-cases/locations', true).get().json(),
})
